import { render, staticRenderFns } from "./OrderDateGroup.vue?vue&type=template&id=78f16b6a&scoped=true&"
import script from "./OrderDateGroup.vue?vue&type=script&lang=js&"
export * from "./OrderDateGroup.vue?vue&type=script&lang=js&"
import style0 from "./OrderDateGroup.vue?vue&type=style&index=0&id=78f16b6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f16b6a",
  null
  
)

export default component.exports